<template>
  <listUsersAdminComponent />
</template>

<script>
import listUsersAdminComponent from "@/views/users_admin/pages/list_users_admin/components/list_users_admin_component.vue";
export default {
  name: "users_admin",
  components: {
    listUsersAdminComponent,
  },
};
</script>

<style lang="css" scoped>
</style>
